export default "__VITE_ASSET__BUOhKqz6__"